export const BASE_API_URL: string =
  process.env.BASE_API_URL ?? "https://lime-api.test/v1/";

export const GOOGLE_MAPS_API_KEY: string =
  process.env.GOOGLE_MAPS_API_KEY ?? "AIzaSyB37sS05agrnbV4F6Ty3jeFbTnn8OtQjYI";

export const GOOGLE_MAPS_MAP_ID: string =
  process.env.GOOGLE_MAPS_MAP_ID ?? "cf68b7ed0058013f";

export const GOOGLE_MAPS_API_BASE_URL = "https://maps.googleapis.com/maps/api/";

export const GOOGLE_MAPS_API_PLACE_SEARCH_URL =
  GOOGLE_MAPS_API_BASE_URL + "place/findplacefromtext/json";

export const GLOBAL_ENV = process.env.GLOBAL_ENV ?? null;

export const SENTRY_DSN = process.env.SENTRY_DSN ?? null;
